export function setLocalStorageItem(key: string, data: Object, _localStorage: Storage = window.localStorage) {
  if (!_localStorage) return;

  _localStorage.setItem(key, JSON.stringify(data));
}

export function getLocalStorageItem(key: string, _localStorage: Storage = window.localStorage) : string {
  if (!_localStorage) return undefined;

  const item = _localStorage.getItem(key);

  return JSON.parse(item);
}

export function removeLocalStorageItem(key: string, _localStorage: Storage = window.localStorage) {
  if (!_localStorage) return;

  _localStorage.removeItem(key);
}

export function clearLocalStorageOnWindowUnload(key: string) {
  window.onunload = () => {
    removeLocalStorageItem(key);
  };
}



// WEBPACK FOOTER //
// ./src/js/libs/LocalStorage.js